export default "__VITE_ASSET__bRGp5l3nOZD9jNRYAfj65Q__"